import React, { useCallback, useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { useModal } from '@xsolla/ui-modal';

import { BabkaOauthModal } from '../../components';

type UseBabkaOauthModalProps = {
  showBabkaLogin: boolean;
} & Pick<RouteComponentProps, 'history' | 'location'>;

type UseBabkaOauthModalReturn = {
  openCreateModal: () => void;
};

const CREATE_CLIENT_PARAM = 'createClient';

export const useBabkaOauthModal = ({
  history,
  location,
  showBabkaLogin
}: UseBabkaOauthModalProps): UseBabkaOauthModalReturn => {
  const searchParams = new URLSearchParams(location.search);
  const shouldOpenModal = searchParams.get(CREATE_CLIENT_PARAM) === 'true';

  const handleCloseModal = useCallback(() => {
    const newSearchParams = new URLSearchParams(location.search);

    if (newSearchParams.has(CREATE_CLIENT_PARAM)) {
      newSearchParams.delete(CREATE_CLIENT_PARAM);
      const newSearch = newSearchParams.toString();
      const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ''}`;

      history.replace(newUrl);
    }

    closeCreateModal();
  }, [history, location]);

  const [openCreateModal, closeCreateModal] = useModal(
    () => <BabkaOauthModal onClose={handleCloseModal} />,
    [handleCloseModal]
  );

  useEffect(() => {
    if (shouldOpenModal && showBabkaLogin) {
      openCreateModal();
    }
  }, [shouldOpenModal, showBabkaLogin, openCreateModal]);

  return { openCreateModal };
};
